import { EXTERNAL_SHARE, ACCESS_LINK } from '@confluence/named-routes/entry-points/routes.ts';
import { expVal } from '@confluence/feature-experiments';

export const isExternalShareRequest = (): boolean => {
	if (expVal('shareable_links_m0', 'isEnabled', false)) {
		return (
			!!EXTERNAL_SHARE.match(window.location.pathname) ||
			!!ACCESS_LINK.match(window.location.pathname)
		);
	}
	return !!EXTERNAL_SHARE.match(window.location.pathname);
};
